import { useEffect } from "react";
import { X } from "lucide-react";
import { useLanguage } from "../i18n";
import { copy } from "../siteContent";

export default function PrivacyDialog({ open, onClose }) {
  const { language } = useLanguage();
  const t = copy[language].privacy;

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="privacy-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button className="dialog-close" type="button" onClick={onClose} aria-label={t.close}>
          <X size={22} />
        </button>
        <p className="section-label">PK-FORENSICS</p>
        <h2 id="privacy-title">{t.title}</h2>
        <p className="privacy-updated">{t.updated}</p>
        <p className="privacy-intro">{t.intro}</p>
        <div className="privacy-sections">
          {t.sections.map(([title, body]) => (
            <div key={title}>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          ))}
        </div>
        <button className="button button-dark" type="button" onClick={onClose}>{t.close}</button>
      </section>
    </div>
  );
}
